export const DATE_FORMATS = [
  //формат для даты
  'dd.MM.yyyy', 'dd.MM', 'MM.yyyy', 'dd-MM-yyyy', 'dd-MM', 'MM-yyyy',
  //дата + время
  'dd.MM.yyyy HH:mm:ss', 'dd.MM HH:mm:ss', 'MM.yyyy HH:mm:ss', 'dd-MM-yyyy HH:mm:ss', 'dd-MM HH:mm:ss', 'MM-yyyy HH:mm:ss',
  //дата + время без секунд
  'dd.MM.yyyy HH:mm', 'dd.MM HH:mm', 'MM.yyyy HH:mm', 'dd-MM-yyyy HH:mm', 'dd-MM HH:mm', 'MM-yyyy HH:mm'] as const;

export type DateFormat = typeof DATE_FORMATS[number];
